module.exports = new __parcel__URL__("header-logo.54c6c482.png").toString();